export default __webpack_public_path__ + "static/media/1t.4741a930.jpg";